import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  PagedStaffEventAudit,
  PagedScheduledEventAudit,
  PagedStaffEventBusinessPersonAudit,
  StaffEventSkeleton
} from './+models/staff-event-audit.model';

@Injectable()
export class StaffEventAuditService {
  constructor(private readonly http: HttpClient) {}

  getStaffEventSkeletons() {
    const url = '/sdapi/pre-flight/StaffEventAudit/StaffEventSkeletons';
    return this.http.get<StaffEventSkeleton[]>(url);
  }

  getStaffEventAudits(
    staffEventId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/pre-flight/StaffEventAudit/${staffEventId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedStaffEventAudit>(url);
  }

  getScheduledEventAudits(
    scheduledEventId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/pre-flight/StaffEventAudit/ScheduledEvents/${scheduledEventId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedScheduledEventAudit>(url);
  }

  getStaffEventBusinessPersonAudits(
    staffEventBusinessPersonId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/pre-flight/StaffEventAudit/StaffEventBusinessPersons/${staffEventBusinessPersonId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedStaffEventBusinessPersonAudit>(url);
  }
}
